module.exports = __webpack_public_path__ + "img/hggkk.a211c810.jpg";